<div id="statusContent" class="content">
  <div id="back_to_dashboard" class="back-link-wrapper">
    <a [routerLink]="['/']" class="back-link">
      <span id="applicationStatus_backToDashboard" class="crm-industrial-font icon-back"></span>
      {{appStrings.link_backToDashboard}}</a>
  </div>
  <div id="title" class="title">
    <h1 id="accountName">Offline history</h1>
  </div>
  <mat-tab-group animationDuration="0ms" mat-align-tabs="left" [selectedIndex]="selectedTab"
    (selectedIndexChange)="updateTab($event)">
    <mat-tab id="errorListDashboardTab" label="{{appStrings.errorList_label}}">
      <ng-template matTabContent>
        <div id="errorListApp" class="dashboard-item">
          <app-error-list></app-error-list>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab id="syncHistoryDashboardTab" label="{{appStrings.synchronization_label}}">
      <ng-template matTabContent>
        <div id="syncHistoryApp" class="dashboard-item">
          <app-sync-history></app-sync-history>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
